<template>
  <div class="seller-account-info">
    <artmisads-modal :open="true" width="1000px" :footer="false" @cancel="emit('update:visible', false)">
      <div class="content">
        <a-spin :spinning="showLoading">
          <h2>Account Info</h2>
          <div class="flex-wrapper">
            <div class="flex-item">
              <div class="flex-item-label">Account Name</div>
              <div class="flex-item-value account-name">{{ accountInfo.accountName || '-' }}<br>
                {{ accountInfo.email }}
              </div>
            </div>
            <div class="flex-item">
              <div class="flex-item-label">Marketplace</div>
              <div class="flex-item-value">{{ seller.countryCode }}</div>
            </div>
            <div class="flex-item">
              <div class="flex-item-label">Registry Date</div>
              <div class="flex-item-value">{{ accountInfo.registryTimestamp ?
                moment(accountInfo.registryTimestamp).format('YYYY-MM-DD') : '-' }}</div>
            </div>
          </div>
          <h2>Payment Details</h2>
          <div class="flex-wrapper">
            <div class="flex-item">
              <div class="flex-item-label">Total Amount</div>
              <div class="flex-item-value">{{ billingAgg?.totalAmount ? currency : '' }}{{ billingAgg?.totalAmount || 0 }}
              </div>
            </div>
            <div class="flex-item">
              <div class="flex-item-label">Paid Amount</div>
              <div class="flex-item-value">{{ billingAgg?.totalPaidAmount ? currency : '' }}{{ billingAgg?.totalPaidAmount
                || 0 }}</div>
            </div>
            <div class="flex-item">
              <div class="flex-item-label">Pending Amount</div>
              <div class="flex-item-value">{{ billingAgg?.totalPendingAmount ? currency : '' }}{{
                billingAgg?.totalPendingAmount || 0 }}</div>
            </div>
            <div class="flex-item">
              <artmisads-select-button @click="goToCreateMultipleInvoice" :disabled="selectedRowsList.length === 0">Create Multiple Invoice</artmisads-select-button>
            </div>
          </div>
          <artmisads-table :columns="columns" :dataSource="billingList"
            :row-key="record=>record.billingId"
            :pagination="pagination.total > pagination.pageSize ? pagination : false"
            :row-selection="{ selectedRowKeys: selectedRowKeysList, onChange: onSelectChange }"
            >
            <template #bodyCell="{ column, text,record }">
              <template v-if="['pending', 'paidAmount', 'amount'].indexOf(column.key) != -1">
                <span v-if="text">
                {{ setUnit(text) }}  {{ currency }}{{ setAmount(text) }}
                </span>
                <span v-else>0</span>
              </template>
              <template v-else-if="column.key === 'date'">
                {{ moment(text).format('YYYY-MM') }}
              </template>
              <template v-else-if="column.key === 'invoice'">
                <a href="javascript:void(0)" @click="toInvoicePdf(record)">Download</a>
              </template>
              <template v-else-if="column.key === 'action'">
                 <a href="javascript:void(0)" @click="setDetailData(record,'detail')">Details</a>
              </template>
            </template>

          </artmisads-table>
        </a-spin>
      </div>
      <detailModal ref="detailModalRef" @update:visible="updateVisible" :setDetailData="setDetailData" :detailData="detailData" :hasCompleteInfo="hasCompleteInfo"
      :setShowNotice="setShowNotice" v-if="detailData.type === 'detail'" />
    </artmisads-modal>
    
  </div>
</template>

<script setup>
import { useRouter } from "vue-router"
import moment from 'moment';
import { ref, computed } from 'vue';
import { operatorSellerApi } from '~/server/index';
import { CURRENCY_MAPPER } from '~/contants/common';
import { setUnit, setAmount } from '~/utils/index';
import detailModal from './detailModal';
const router = useRouter()
const emit = defineEmits(['update:visible']);
const selectedRowKeysList = ref([]);
const selectedRowsList = ref([]);
const onSelectChange = (selectedRowKeys, selectedRows) => {
  const currentPageKeys = billingList.value.map((item) => item.billingId)
  const preservedKeys = selectedRowKeysList.value.filter(
    (key) => !currentPageKeys.includes(key)
  )
  const preservedRows = selectedRowsList.value.filter(
    (row) => !currentPageKeys.includes(row.billingId)
  )

  selectedRowKeysList.value = [...preservedKeys, ...selectedRowKeys]
  selectedRowsList.value = [...preservedRows, ...selectedRows]
}
const { seller } = defineProps(['seller'])
const accountInfo = ref({});
const billingAgg = ref({});
const billingList = ref([]);
const detailData = ref({});
const hasCompleteInfo = ref(true);

const countryCode = ref(seller.countryCode);
const showLoading = ref(false);
const currency = computed(() => CURRENCY_MAPPER[countryCode.value]?.currency || '$');
const columns = [{
  key: 'date',
  title: 'Date',
  dataIndex: 'billingDateTimestamp',
},
{
  key: 'Type',
  title: 'Billing Type',
  dataIndex: 'billingType',
},
{
  key: 'amount',
  title: 'Amount',
  dataIndex: 'amount',
  width: '150px',
},

{
  title: 'Paid',
  dataIndex: 'paidAmount',
  key: 'paidAmount',
  width: '150px',

},
{
  key: 'pending',
  title: 'Pending',
  dataIndex: 'pendingAmount',
  width: '150px',

},
{
  title: 'Status',
  dataIndex: 'status',
  key: 'status',
},
{
  title: 'Invoice',
  dataIndex: 'invoice',
  key: 'invoice',
},
{
  title:'Actions',
  dataIndex:'action',
  key:'action',
}
]
const pagination = ref({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: false,
  hideOnSinglePage: true,
  onChange: () => {
    getBillingList()
  },
})

function getBillingList() {
  showLoading.value = true

  const params = {
    sellerId: seller.id,
    countryCode: seller.countryCode,
    page: pagination.value.current,
    size: pagination.value.pageSize,
  }

  operatorSellerApi.getSellerPayments(params).then((data) => {
    showLoading.value = false

    if (data) {
      if (params.page === 1) {
        billingAgg.value = data.sellerBillingAgg;
        accountInfo.value = { ...data.sellerAccountInfo, email: data.email };
        countryCode.value = data.countryCode || 'US';
        pagination.value.total = data.sellerBillings.total
      }

      if (data.sellerBillings.total) {
        billingList.value = data.sellerBillings.data.map(item => {
          return {
            ...item,
            // todo: 精度问题
            pendingAmount: (item.amount - item.paidAmount).toFixed(2),
            status: item.status.split('_').map(i => {
              return i.charAt(0).toUpperCase() + i.slice(1)
            }).join(' ')
          }
        });
        console.log(billingList.value,'数据')
      }
    }
  })
}
const setDetailData=(item,type)=>{
  detailData.value = {
    ...item,
    type: type,
  }
}
const goToCreateMultipleInvoice=()=>{
  // router.push({ path: `/operator/merge-pdf/1`,query:{data:JSON.stringify(selectedRowsList.value) } })
   const { href } = router.resolve({path: `/operator/merge-pdf/1`,query:{data:JSON.stringify(selectedRowsList.value) } })
    window.open(href, '_blank')
}
const toInvoicePdf=(record)=>{
  const { href } = router.resolve({ path: `/operator/invoice-pdf/${record.billingId}` })
    window.open(href, '_blank')
}
getBillingList()
</script>

<style lang="less" scoped>
.content {
  h2 {
    color: #333;
    font-size: 16px;

    &:not(:first-child) {
      margin-top: 20px;
    }
  }
}

.flex-wrapper {
  gap: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.flex-item {
  flex: 1;
  gap: 10px;
  display: flex;
  align-items: center;

  &-label {
    color: #999;
    font-size: 14px;
    white-space: nowrap;
  }

  &-value {
    color: #333;
    font-size: 16px;
    white-space: nowrap;

    &.account-name {
      overflow: hidden;
      max-width: 200px;
      line-height: 18px;
      text-overflow: ellipsis;
    }
  }
}

.artmisads-table {
  margin-top: 30px;
}
</style>
